import { cn } from '@/lib/cn';
import { t } from '@/i18n';

/**
 * Marka işareti — biyolink.com'un kelime-işareti.
 *
 * Logo "BIYOLINK" yazısının kendisidir; markanın tek simgesi "O" harfindeki yeşil
 * halka (favicon.svg oradan türetildi). Kelime-işareti "Biyolink"i zaten yazdığı için
 * yanına yalnız "Pazaryeri" eklenir — görselin alt metni ile birleşince ekran okuyucu
 * tam adı okur.
 *
 * `width`/`height` özgün ölçülerdir: yer ayrılsın ve logo yüklenirken başlık zıplamasın.
 */
export function BrandMark({
  className,
  imageClassName,
  showSuffix = true,
}: {
  className?: string;
  imageClassName?: string;
  showSuffix?: boolean;
}) {
  return (
    <span className={cn('flex items-center gap-2', className)}>
      <img
        src="/biyolink-logo.webp"
        alt={t('app.brand')}
        width={375}
        height={65}
        className={cn('h-5 w-auto sm:h-6', imageClassName)}
      />
      {showSuffix && (
        <span className="hidden text-base font-semibold text-slate-700 sm:inline">
          {t('app.suffix')}
        </span>
      )}
    </span>
  );
}
